"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
require("core-js/modules/es.array.concat");
require("core-js/modules/es.array.is-array");
require("core-js/modules/es.date.now");
require("core-js/modules/es.date.to-string");
require("core-js/modules/es.object.to-string");
require("core-js/modules/es.regexp.to-string");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.action = void 0;
var _immer = require("immer");
var _constant = require("../constant");
var _createStore = require("../createStore");
var _index = require("../utils/index");
var _checkPatches = require("../checkPatches");
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0) { ; } } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; } /* eslint-disable func-names */
var action = function action(target, key, descriptor) {
  var fn = descriptor.value;
  if (typeof fn !== 'function') {
    throw new Error("".concat(String(key), " can only be decorated by '@action' as a class method."));
  }
  var value = function value() {
    var _this = this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    var time;
    if (process.env.NODE_ENV === 'development') {
      time = Date.now();
    }
    if (typeof (0, _index.getStagedState)() === 'undefined') {
      try {
        var _this$_getLastState, _this$_getLastState2;
        var lastState = (_this$_getLastState = (_this$_getLastState2 = this._getLastState) === null || _this$_getLastState2 === void 0 ? void 0 : _this$_getLastState2.call(this)) !== null && _this$_getLastState !== void 0 ? _this$_getLastState : this[_constant.storeKey].getState();
        var state;
        var patches = [];
        var inversePatches = [];
        var recipe = function recipe(draftState) {
          (0, _index.setStagedState)(draftState);
          fn.apply(_this, args);
        };
        var enablePatches = (0, _createStore.getPatchesToggle)();
        if (enablePatches) {
          var _produceWithPatches = (0, _immer.produceWithPatches)(lastState, recipe);
          var _produceWithPatches2 = _slicedToArray(_produceWithPatches, 3);
          state = _produceWithPatches2[0];
          patches = _produceWithPatches2[1];
          inversePatches = _produceWithPatches2[2];
        } else {
          state = (0, _immer.produce)(lastState, recipe);
        }
        (0, _index.setStagedState)(undefined);
        var changed = lastState !== state;
        if (process.env.NODE_ENV === 'development') {
          if (!changed) {
            var _console;
            (_console = console).warn.apply(_console, ["There are no state updates to method '".concat(this[_constant.identifierKey], ".").concat(key.toString(), "' with arguments:")].concat(args));
          }
          // performance checking
          var executionTime = Date.now() - time;
          if (executionTime > 100) console.warn("The execution time of method '".concat(this[_constant.identifierKey], ".").concat(key.toString(), "' is ").concat(executionTime, " ms, it's recommended to use 'dispatch' API."));
          // performance detail: https://immerjs.github.io/immer/docs/performance
        }

        if (changed) {
          var _this$_handleState;
          (_this$_handleState = this._handleState) === null || _this$_handleState === void 0 ? void 0 : _this$_handleState.call(this, state);
          var _action = _objectSpread({
            type: this[_constant.identifierKey],
            method: key,
            params: args,
            _state: state,
            _usm: _constant.usm
          }, enablePatches ? {
            _patches: patches,
            _inversePatches: inversePatches
          } : {});
          if (process.env.NODE_ENV === 'development') {
            var requiredWarning = (0, _checkPatches.checkPatches)(lastState, _action);
            if (requiredWarning) {
              console.warn("The state update operation in the method '".concat(this[_constant.identifierKey].toString(), ".").concat(key.toString(), "'  is a replacement update operation. If there is a performance issue, be sure to use mutation updates to ensure the minimum set of update patches."));
            }
          }
          this[_constant.storeKey].dispatch(_action);
        }
      } finally {
        (0, _index.setStagedState)(undefined);
      }
    } else {
      // enable staged state mode.
      fn.apply(this, args);
    }
  };
  return _objectSpread(_objectSpread({}, descriptor), {}, {
    value: value
  });
};
exports.action = action;
//# sourceMappingURL=action.js.map
